import React from 'react'
import { CFView, Text, Space } from 'components'
import { css } from 'emotion'
import { logowhite } from 'images'
import { MEDIA_QUERY } from 'styles'

export default ({
  AddressInputElement,
  CancelButtonElement,
  SubmitButtonElement,
}) => (
  <div className={styles.container}>
    <CFView column w="100%">
      <CFView column w="100%" center mb="4rem">
        <img src={logowhite} alt="Ebisu" width="150" />
      </CFView>
      <CFView mb="2rem">
        <Text heading2 h3 center>
          Please enter your address:
        </Text>
      </CFView>
      <CFView mb="2rem">{AddressInputElement}</CFView>
      <CFView row justifyBetween mt="2rem">
        {CancelButtonElement}
        <Space w2 />
        {SubmitButtonElement}
      </CFView>
    </CFView>
  </div>
)

const styles = {
  container: css({
    backgroundColor: '#232323',
    color: 'white',
    padding: '4rem',
    borderRadius: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '52rem',
    height: '41rem',
    [MEDIA_QUERY.SM]: {
      padding: '2rem',
      width: '100%',
    },
  }),
}
